import { ApiError, ProblemTypes } from '../../interop/problem-details';
import { EventSnippet, ShowErrorEvent } from '../../interop/webmodule-interop';
import { LangShowError } from '../../../localization/webmodule-common/other/ui/show-error-lang';

let _handler: ShowErrorEvent | null = null;

export function setErrorDialogEventHandler(handler: ShowErrorEvent) {
  _handler = handler;
}

/**
 *
 * @param item abstracted show error removed from implementation details
 * @param title
 * @returns
 */
export async function showError(
  item: Error | ApiError | string | null,
  title?: EventSnippet
) {
  if (item === null) return;

  // Convert string to ApiError
  if (typeof item === 'string') {
    item = new ApiError({
      type: ProblemTypes.InternalError,
      title: 'Error',
      status: 0,
      detail: item
    });
  }

  // Convert plain Error to ApiError
  if (item instanceof Error && !(item instanceof ApiError)) {
    item = new ApiError({
      type: ProblemTypes.InternalError,
      title: item.name,
      status: 0,
      detail: item.message,
      stackTrace: item.stack
    });
  }

  if (!title) title = () => LangShowError.exceptionError();

  await _handler?.(item, title);
}
